import { IFavoriteEntity } from './favoriteEntity';

interface IOffersByRealtyOfferIdState {
  folderOffers: IFavoriteEntity[];
  status: EGetOffersByRealtyOfferIdStatus;
  noteStatus: EOfferNoteStatus;
}

enum EGetOffersByRealtyOfferIdStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

enum EOfferNoteStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export { IOffersByRealtyOfferIdState, EGetOffersByRealtyOfferIdStatus, EOfferNoteStatus };
